import { computed, ref } from 'vue'
import axios from 'axios'
import camelcaseKeys from 'camelcase-keys'

export type CouponCodeFormType = {
  code: string
  isInputShown: boolean
  isLoading: boolean
  errors: string
  isValid: boolean
  isLimitedTimeOffer: boolean
}

export const useCouponCode = () => {
  const coupon = ref<CouponCodeFormType>({
    code: '',
    isInputShown: false,
    isLoading: false,
    errors: '',
    isValid: false,
    isLimitedTimeOffer: false,
  })

  const couponCodeField = computed({
    get: () => {
      if (coupon.value.isLimitedTimeOffer) return ''
      return coupon.value.code
    },
    set: (value: string) => {
      coupon.value.code = value
      coupon.value.isLimitedTimeOffer = false
      coupon.value.errors = ''
      coupon.value.isValid = false
    },
  })

  const checkCouponCode = async (successCallback) => {
    try {
      coupon.value.isLoading = true
      const { data } = await axios.get('/stripe/coupon_check', {
        params: { coupon_code: coupon.value.code },
      })

      coupon.value.isValid = data.is_valid

      if (!data.is_valid) {
        return (coupon.value.errors = 'Invalid coupon code')
      }

      successCallback({
        plans: camelcaseKeys(data.plans),
        teamPlans: camelcaseKeys(data.teamPlans),
      })
    } catch (_) {
      coupon.value.errors =
        'Something went wrong while applying the coupon code. Please try again.'
    } finally {
      coupon.value.isLoading = false
    }
  }

  const toggleCouponCodeInput = () => {
    coupon.value.isInputShown = !coupon.value.isInputShown
  }

  const clearCouponErrors = () => {
    coupon.value.errors = ''
  }

  return {
    coupon,
    couponCodeField,
    checkCouponCode,
    toggleCouponCodeInput,
    clearCouponErrors,
  }
}
